module.exports = __webpack_public_path__ + "img/target.7cec87b3.svg";